module.exports = __webpack_public_path__ + "img/box_pro_six_4.30f9054d.jpg";